const React = require('react')
const PropTypes = require('prop-types')
const NavLink = require('./nav_link')
const radio = require('lib/radio')

class SignupLink extends React.Component {

    constructor() {
        super()
        this.onClick = this.onClick.bind(this)
    }

    componentDidMount() {
        // radio.metrics_signup.trigger('nav:signup:shown')
    }

    onClick(e) {
        radio.metrics_signup.trigger('nav:signup:clicked')
        radio.topnav.trigger('nav:signup:clicked', e)

        if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render() {
        const { href, desktop_text, mobile_text, condition } = this.props

        return (
            <NavLink
                condition={condition}
                href={href}
                onClick={this.onClick}
                className="signup-link"
                data-metric-channel="metrics_nav"
                data-metric-event="clicked:signup"
                >
                <strong>
                    <span className="not-mobile">{desktop_text}</span>
                    <span className="is-mobile">{mobile_text}</span>
                </strong>
            </NavLink>
        )
    }
}

SignupLink.propTypes = {
    href: PropTypes.string.isRequired,
    desktop_text: PropTypes.string,
    mobile_text: PropTypes.string,
    onClick: PropTypes.func,
    condition: PropTypes.bool,
}

SignupLink.defaultProps = {
    href: '/welcome',
    desktop_text: 'Get started for free',
    mobile_text: 'Get your page',
    condition: true,
}

module.exports = SignupLink
